const prefix = '/files';

export const ApiFilesUrls = {
  choices: `${prefix}/api-schema`,
  retrieve: `${prefix}/:id`,
  update: `${prefix}/:id`,
  destroy: `${prefix}/:id`,
};
